import { React, Footer } from "mondrian-react";

const FooterComponent = () => {
  const dateNow = new Date().getFullYear();
  return (
    <Footer id="footer">
      © {dateNow} Claro. Todos os direitos reservados.
    </Footer>
  );
};
export default FooterComponent;
